import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useCallback, useEffect } from 'react';
import { TooltipArrow, TooltipCard, TooltipTrigger } from './styles';
import { usePopper } from 'react-popper';
import ReactDOM from 'react-dom';

/**
 * Default Tooltip on hover
 */
var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      content = _ref.content,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'top' : _ref$placement,
      _ref$textAlignment = _ref.textAlignment,
      textAlignment = _ref$textAlignment === void 0 ? 'left' : _ref$textAlignment,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 0 : _ref$delay,
      _ref$portal = _ref.portal,
      portal = _ref$portal === void 0 ? false : _ref$portal,
      _ref$withArrow = _ref.withArrow,
      withArrow = _ref$withArrow === void 0 ? false : _ref$withArrow,
      backgroundColor = _ref.backgroundColor,
      _ref$selfClose = _ref.selfClose,
      selfClose = _ref$selfClose === void 0 ? false : _ref$selfClose,
      _ref$hoverAnimation = _ref.hoverAnimation,
      hoverAnimation = _ref$hoverAnimation === void 0 ? true : _ref$hoverAnimation;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      setTimer = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      triggerRef = _useState6[0],
      setTriggerRef = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      popperRef = _useState8[0],
      setPopperRef = _useState8[1];

  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2),
      arrowRef = _useState10[0],
      setArrowRef = _useState10[1];

  var _usePopper = usePopper(triggerRef, popperRef, {
    placement: placement,
    modifiers: [{
      name: 'offset',
      enabled: true,
      options: {
        offset: [0, withArrow ? 24 : 16]
      }
    }, {
      name: 'flip',
      enabled: true
    }, {
      name: 'arrow',
      enabled: withArrow,
      options: {
        element: arrowRef
      }
    }]
  }),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes;

  var handleEnter = useCallback(function () {
    if (!selfClose) {
      setTimer(function (prevTimer) {
        if (prevTimer) {
          clearTimeout(prevTimer);
        }

        return setTimeout(function () {
          setVisible(true);
        }, Math.max(delay, 500));
      });
    }
  }, [delay, selfClose]);
  var handleOver = useCallback(function () {
    if (!selfClose && !visible) {
      setTimer(function (prevTimer) {
        if (prevTimer) {
          clearTimeout(prevTimer);
        }

        return setTimeout(function () {
          setVisible(true);
        }, Math.max(delay, 500));
      });
    }
  }, [delay, selfClose, visible]);
  var handleLeave = useCallback(function () {
    if (!selfClose) {
      setTimer(function (prevTimer) {
        if (prevTimer) {
          clearTimeout(prevTimer);
        }

        return setTimeout(function () {
          setVisible(false);
        }, 500);
      });
    }
  }, [selfClose]);
  useEffect(function () {
    if (selfClose) {
      var timer = setTimeout(function () {
        setVisible(true);
      }, 800);
      return function () {
        return clearTimeout(timer);
      };
    }

    return function () {};
  }, [selfClose]);
  var handleScroll = useCallback(function () {
    return setVisible(false);
  }, []);
  var handleClick = useCallback(function (event) {
    if (popperRef && !popperRef.contains(event.target)) setVisible(false);
  }, [popperRef]);
  useEffect(function () {
    var addEvents = function addEvents() {
      document.addEventListener('scroll', handleScroll);
      document.addEventListener('click', handleClick);
    };

    var removeEvents = function removeEvents() {
      document.removeEventListener('scroll', handleScroll);
      document.removeEventListener('click', handleClick);
    };

    if (selfClose && visible) addEvents();
    return removeEvents;
  }, [visible, selfClose, handleClick, handleScroll]);
  var tooltipCard = /*#__PURE__*/React.createElement(TooltipCard, Object.assign({
    id: "tooltip",
    ref: setPopperRef,
    style: styles.popper
  }, attributes.popper, {
    textAlignment: textAlignment,
    "data-enter": visible || undefined,
    onMouseEnter: handleEnter,
    onMouseOver: handleOver,
    onMouseLeave: handleLeave,
    backgroundColor: backgroundColor
  }), withArrow && /*#__PURE__*/React.createElement(TooltipArrow, {
    ref: setArrowRef,
    style: styles.arrow,
    backgroundColor: backgroundColor
  }), content);
  var containerElement = portal && document.querySelector('body');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TooltipTrigger, {
    ref: setTriggerRef,
    onMouseEnter: handleEnter,
    onMouseOver: handleOver,
    onMouseLeave: handleLeave,
    hoverAnimation: hoverAnimation
  }, children), visible && (containerElement ? ReactDOM.createPortal(tooltipCard, containerElement) : tooltipCard));
};

export { Tooltip };